import { getUserSession } from "../../core/util/core/Session"

export const chooseProfileFilter = () => {
    const session = getUserSession()

    const { loggedUserInfo } = session

    if (loggedUserInfo.pdc_project_ids) {
        return { pdc_project_ids: loggedUserInfo.pdc_project_ids }
    } else if (loggedUserInfo.pdc_entity_id) {
        return { pdc_entity_id: loggedUserInfo.pdc_entity_id }
    } else if (loggedUserInfo.pdc_company_id) {
        return { pdc_company_id: loggedUserInfo.pdc_company_id }
    }else{
        return {}
    }
}